var React = require('react');

function Fog (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M208 464H80a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm416 0H288a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h336a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-48-64v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h544a16 16 0 0 0 16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M64 224c0-42.5 27.8-78.2 66.1-90.8A113.72 113.72 0 0 1 128 112 111.94 111.94 0 0 1 240 0c43.3 0 80.4 24.8 99 60.8C353.7 43.3 375.4 32 400 32a80 80 0 0 1 80 80 78.09 78.09 0 0 1-1.6 16.2c.5 0 1-.2 1.6-.2a96 96 0 0 1 0 192H160a96 96 0 0 1-96-96z","className":"fa-primary","key":2})]);
}

Fog.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Fog;

Fog.default = Fog;
